
<script>
export default {
  data: ()=>({
    sorting: {
    },
  }),
  computed: {
    sortings() {
      let arr = [];
      for (let key in this.sorting) {
        if (this.sorting[key].index > 0)
          arr.push({
            key: key,
            order: this.sorting[key].order,
            index: this.sorting[key].index
          });
      }
      arr = arr.sort((o1, o2) => o1.index - o2.index);
      return arr;
    },
  },
  methods: {
    toggleSort(header) {
      if (!header.sortKey) return;
      if (this.sorting[header.sortKey].index <= 0) {
        this.sorting[header.sortKey].index = this.sortings.length + 1;
        this.sorting[header.sortKey].order = "desc";
      } else if (this.sorting[header.sortKey].order == "desc") {
        this.sorting[header.sortKey].order = "asc";
      } else if (this.sorting[header.sortKey].order == "asc") {
        this.sorting[header.sortKey].index = -1;
        this.sorting[header.sortKey].order = null;
      } else {
        window.console.error(`toggleSort, unknown status`);
      }
      this.reloadDataTable();
    },
  }
};
</script>
